import type React from "react";
import { Modal, Form, Input, Button } from "antd";
import { authQueryFactory } from "@/console/apis/auth/queryFactory";

interface ForgotPasswordModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({
  isVisible,
  onClose,
}) => {
  const [form] = Form.useForm();
  const { mutate: resetPassword } = authQueryFactory.resetPassword();

  const handleSubmit = async (values: {
    email: string;
    first_name: string;
    last_name: string;
    gym_name: string;
  }) => {
    resetPassword(values, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal
      title="Find Password"
      open={isVisible}
      onCancel={onClose}
      footer={null}
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, message: "Please enter your email" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="first_name"
          label="First Name"
          rules={[{ required: true, message: "Please enter your first name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="last_name"
          label="Last Name"
          rules={[{ required: true, message: "Please enter your last name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="gym_name"
          label="Studio Name"
          rules={[{ required: true, message: "Please enter your studio name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Reset Password
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ForgotPasswordModal;
